// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__rJB1i","lds-ring":"loader_lds-ring__fdECz","active":"loader_active__1-eHy"};